import http from '@/api/http'

export default {
    getActiveNewsListByCategory(cb, form) {
        http.post('/api/news/getActiveNewsListByCategory', cb, form);
    },
    getNewsById(cb, form) {
        http.post('/api/news/getNewsById', cb, form);
    },
}